module.exports = __webpack_public_path__ + "media/images/rx-e5be79685cbcaed9a07df27a3734c1ee.png";